import React from 'react'
import { useTranslation } from 'react-i18next'

import PlacesFilter from '../../../../containers/places/filters/PlacesFilter'
import MinicrudsFilter from '../../../../containers/minicruds/filters/MinicrudsFilter'
import SideModalFiltersWrapper from '../../../../components/filter/SideModalFiltersWrapper'
import ActivatedFilter from '../../../../components/filter/ActivatedFilter'

const FilterModal = ({ open, onClose }) => {
  const { t } = useTranslation('common')

  return (
    <SideModalFiltersWrapper open={open} onClose={onClose}>
      <PlacesFilter presentation="list" label={t('entity.location')} type="location" />
      <PlacesFilter presentation="list" label={t('entity.person')} type="person" icon="IoMdPeople" />
      <PlacesFilter presentation="list" label={t('entity.fleet')} type="fleet" icon="IoIosCar" />
      <MinicrudsFilter entity="type " presentation="list" label={t('types')} />
      <ActivatedFilter presentation="list" />
    </SideModalFiltersWrapper>
  )
}

export default FilterModal
